<template>
	<div class="vg">
		
		<div @click="toList(1101)" class="vg_item">
			<img src="./source/1.png" alt="" />
			<div class="vg_item_son">
				<div>
					<div class="vg_item_son_1">五星酒店游泳健身</div>
					<div class="vg_item_son_2">五星泳动 活力焕新</div>
					<div class="vg_item_son_3">立即预订</div>
				</div>
			</div>
		</div>

		<div @click="toOrder()" class="vg_order">
			<div class="vg_order_item">
				<div>
					<div>订单</div>
					<div>列表</div>
				</div>
			</div>
		</div>
		
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				class_id: ''
			}
		},
		mounted() {
			// this.getUserInfo()
		},
		methods: {
			// getUserInfo(){
			// 	var $this = this
			// 	var param = {}
			// 	var qs = require('qs');
			// 	let url = this.api.userApi.demo1_user_info
			// 	this.axios.post(url, qs.stringify(param))
			// 		.then((res) => {
			// 			// console.log(res)
			// 		}).catch((error) => {
			// 			console.warn(error)
			// 			$this.$toast(error.msg?error.msg:error.message);
			// 		})
			// },
			
			toList(e) {
				// localStorage.setItem('token', res.data.token)
				if(!localStorage.getItem('token')){
					this.$router.push({
						name:'login'
					})
					return
				}
				this.$router.push({
					name: 'venue_goods_list',
					params: {
						class_id: e
					}
				})
			},
			toOrder(){
				if(!localStorage.getItem('token')){
					this.$router.push({
						name:'login'
					})
					return
				}
				this.$router.push({
					name: 'venue_goods_order'
				})
			},
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;

	.vg {
		width: 100%;
		padding: 30*@vm_base;

		.vg_item {
			width: 100%;
			position: relative;
			margin-bottom: 20*@vm_base;

			img {
				width: 100%;
			}

			.vg_item_son {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				text-align: center;
				color: rgba(255, 255, 255, 1);

				.vg_item_son_1 {
					font-size: 42*@vm_base;
				}

				.vg_item_son_2 {
					font-size: 32*@vm_base;
					letter-spacing: 2*@vm_base;
					padding: 24*@vm_base 0;
				}

				.vg_item_son_3 {
					width: fit-content;
					border: 1*@vm_base solid rgba(255, 255, 255, 0.7);
					border-radius: 40*@vm_base;
					padding: 20*@vm_base 50*@vm_base;
					margin: 0 auto;
					font-size: 28*@vm_base;
				}
			}
		}

		.vg_foot {
			// position: fixed;
			width: 100%;
			// bottom: 0;
			// left: 0;
			padding: 60*@vm_base 30*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			color: #666;
			font-size: 24*@vm_base;

			.vg_foot_big {
				font-size: 38*@vm_base;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 30*@vm_base;
				font-weight: bold;
				color: #333;

				div {
					text-decoration: underline;
					font-weight: bold;
				}
			}
		}
	}
	.vg_order{
		position: fixed;
		right: 0;
		bottom: 200*@vm_base;
		padding:10*@vm_base 20*@vm_base 10*@vm_base 10*@vm_base;
		border-radius: 60*@vm_base 0 0 60*@vm_base;
		background: rgba(247, 127, 40, 1);
		.vg_order_item{
			width: 80*@vm_base;
			height: 80*@vm_base;
			border: 1*@vm_base solid rgba(255, 255, 255, 0.5);
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			font-size: 24*@vm_base;
			color: rgba(255, 255, 255, 1);
			border-radius: 50%;
			div{
				line-height: 1.1;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/demo1/vgood.vue